// import * as React from 'react';

// import { SEO } from 'main/components';

// export class Download extends React.Component {
//   render() {
//     return (
//       <>
//         <SEO seoTitle="ORQA - Downloads" />
//         <section className="page">
//           <div className="wrapper wrapper--narrow">
//             <h1 className="t-beta s-bottom--med">
//               Orqa FPV&thinsp;&mdash;&thinsp;Product PR Photos repository
//             </h1>
//             <div className="page__content">
//               <div className="page__table">
//                 <div className="page__table__item">
//                   <div className="page__table__item__heading">
//                     <p className="t-eta">Orqa FPV.P1 PR Photos</p>
//                   </div>
//                   <div className="page__table__item__action">
//                     <a
//                       href={require('main/assets/download/Orqa FPV.P1_PR_Photos.zip')}
//                       className="btn btn--sml btn--nopadding"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       onMouseDown={event => event.preventDefault()}
//                     >
//                       Download
//                     </a>
//                   </div>
//                 </div>

//                 <div className="page__table__item">
//                   <div className="page__table__item__heading">
//                     <p className="t-eta">Orqa FPV.One Web Renders</p>
//                   </div>
//                   <div className="page__table__item__action">
//                     <a
//                       href={require('main/assets/download/OrqaFPV_OneRenders_web.zip')}
//                       className="btn btn--sml btn--nopadding"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       onMouseDown={event => event.preventDefault()}
//                     >
//                       Download
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </>
//     );
//   }
// }

import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

export const Download = () => {
  const history = useHistory();
  const [counter, setCounter] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter(prevCounter => prevCounter - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (counter === 0) {
      history.replace('/');
    }
  }, [counter, history]);

  return (
    <>
      <section
        className="page"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          minHeight: '50vh',
        }}
      >
        <div
          className="wrapper wrapper--narrow"
          style={{ textAlign: 'center' }}
        >
          <h1 className="t-beta s-bottom--sml">Redirecting to Homepage</h1>
          <p className="t-zeta s-bottom--sml" style={{ marginBottom: '1rem' }}>
            This page is obsolete and is no longer part of our active website.
            You will be automatically redirected to the Homepage in...
          </p>
          <div
            style={{
              fontSize: '4rem',
              fontWeight: 'bold',
              marginBottom: '1rem',
              minWidth: '60px',
            }}
          >
            {counter}
          </div>
          <p className="t-zeta">
            If you are not redirected, please click{' '}
            <a href="/">Homepage link</a>.
          </p>
        </div>
      </section>
    </>
  );
};
